import './PricingGrid.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { setCompany } from "../../containers/Accounts/store/actions";

import A from 'components/A';
import Button from "../Button";
import H2 from 'components/H2';
import Icon from 'components/Icon';

const pricingOptions = [
    {
        title: 'Basic',
        price: '$199',
        tier: 'basic',
        features: [
            'Unlimited access to all vetted freelancer profiles, work experience and contact information so you can do the hunting yourself',
            'Quick-search options by name, role and/or industry expertise',
            'Real time messaging',
            'Unlimited job postings',
            'Custom business profile'
        ]
    }, {
        title: 'Premium',
        price: '$399',
        tier: 'premium',
        features: [
            'Access to unlimited support from The Hunt Agency: Tell us what you need and we\'ll do the hunting for you, finding a freelance resource within 24-48 hours',
            'Includes freelance scheduling, rate negotiations and the opportunity to provide feedback throughout the project',
            'Unlimited access to all vetted freelancer profiles, work experience and contact information so you can also do your own hunting',
            'Quick-search options by name, role and/or industry expertise',
            'Real time messaging',
            'Unlimited job postings',
            'Custom business profile'
        ]
    }
];

class PricingGrid extends React.Component {
    static propTypes = {
        buttonText: PropTypes.string,
        handleClick: PropTypes.func,
        showButtons: PropTypes.bool
    };

    handleSelectPlanLevel(value) {
        let newCompanyObj = update(this.props.accounts.company, {});
        newCompanyObj.subscriptionTier = value;
        this.props.setCompany(newCompanyObj);
        this.props.changeLocation('/create-your-business-account/form');
    }

    render() {
        return (
            <React.Fragment>
                <ul className="pricing__grid">
                    {pricingOptions.map((option, index) => {
                        return (
                            <li className="pricing__option" key={index}>
                                <div className="pricing__info">
                                    <H2 className="pricing__title">
                                        {option.title}
                                    </H2>

                                    {option.description ? (
                                        <div className="pricing__description">
                                            {option.description}
                                        </div>
                                    ) : null}

                                    <div className="pricing-grid__features">
                                        {option.features.map((feature, i) => (
                                            <div className="pricing-grid__feature" key={i}>
                                                <Icon type="check-circle" />
                                                {feature}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="pricing__price">
                                        <span>{option.price}</span> per month
                                    </div>


                                    <Button onClick={() => {
                                        if(this.props.handleClick) {
                                            this.props.handleClick();
                                        } else {
                                            this.handleSelectPlanLevel(option.tier)
                                        }
                                    }}>
                                        {this.props.buttonText || 'Start free trial'}
                                    </Button>
                                </div>
                            </li>
                        );
                    })}
                </ul>

                <div className="pricing__personalized">
                    Need help finding just the right freelancer? <A href="mailto:jennifer@thehunt.agency?&cc=catherine@thehunt.agency">Contact us</A> for personalized recommendations.
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        setCompany: (companyObj) => dispatch(setCompany(companyObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingGrid);



// WEBPACK FOOTER //
// ./src/components/PricingGrid/index.js